import { render, staticRenderFns } from "./Azure.vue?vue&type=template&id=041da787&scoped=true"
import script from "./Azure.vue?vue&type=script&lang=js"
export * from "./Azure.vue?vue&type=script&lang=js"
import style0 from "./Azure.vue?vue&type=style&index=0&id=041da787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041da787",
  null
  
)

export default component.exports